
import React from "react";
import { motion } from "framer-motion";
import discovery from "../Images/Icons/discovery.png";
import design from "../Images/Icons/design.png";
import development from "../Images/Icons/development.png";
import testingqa from "../Images/Icons/tesingqa.png";
import deployment from "../Images/Icons/deployment.png";
import supportmain from "../Images/Icons/supportmain.png";

const steps = [
    { id: 1, title: "Discovery & Planning", description: "We start by understanding your business needs, goals, and challenges to create a roadmap for your project.", iconImg: discovery, color: "bg-pink-500", textColor: "text-pink-500" },
    { id: 2, title: "Design & Prototyping", description: "Our designers create wireframes and prototypes to visualize the solution before development begins.", iconImg: design, color: "bg-orange-400", textColor: "text-orange-500" },
    { id: 3, title: "Development", description: "Our expert developers build your solution using the latest technologies and best practices.", iconImg: development, color: "bg-teal-400", textColor: "text-teal-500" },
    { id: 4, title: "Testing & QA", description: "Rigorous testing ensures your solution is bug-free, secure, and performs optimally.", iconImg: testingqa, color: "bg-green-400", textColor: "text-green-500" },
    { id: 5, title: "Deployment", description: "We deploy your solution to production, ensuring a smooth transition and minimal disruption.", iconImg: deployment, color: "bg-purple-500", textColor: "text-purple-500" },
    { id: 6, title: "Support & Maintenance", description: "Our team provides ongoing support and maintenance to keep your solution running smoothly.", iconImg: supportmain, color: "bg-red-500", textColor: "text-red-500" }
];

// Duplicate elements for infinite effect
const marqueeSteps = [...steps, ...steps]; 

export default function PartnershipModels() {
  return (
    <div className="flex relative flex-col  py-12  overflow-hidden  text-white">
      {/*  */}
      <div className="p-2 md:ml-5">
      <button className="w-[270px] h-[60px]  relative rounded-full bg-[#432DD7]">Our Process</button>
      <h2 className="text-[40px] font-[700] text-black relative" style={{fontFamily:'PT Sans'}}>Strategic planning ensures</h2>
      <h2 className="text-[40px] font-[400] text-[#432DD7] relative font-[Allison]">efficiency and innovation</h2>
      <h2 className="text-[16px] font-[400] text-[#62739E] max-w-[1200px]">We follow a structured approach to deliver high-quality solutions that meet your business needs. Our process begins with an in-depth understanding of your requirements, ensuring we create tailored strategies that align with your goals. We then move to the planning and design phase, where we develop user-friendly, scalable, and efficient solutions.</h2>
      </div>
      {/* Infinite Scrolling Cards */}
      <div className="w-full overflow-hidden relative mt-10">
        <motion.div
          className="flex gap-8"
          animate={{ x: ["0%", "-100%"] }} // Move content infinitely
          transition={{
            ease: "linear",
            duration: 15,
            repeat: Infinity,
          }}
        >
          {[...marqueeSteps, ...marqueeSteps].map((step, index) => (
            <div
              key={index}
              className="min-w-[280px] md:min-w-[320px] lg:min-w-[350px] flex flex-col p-6 rounded-lg  border border-gray-300"
            >
              {/* Dots Above Cards */}
              <div className="absolute top-[-16px] left-1/2 transform -translate-x-1/2 w-4 h-4 bg-gray-600 rounded-full"></div>

              {/* Colored Icon Background */}
              
                <img src={step.iconImg} alt={step.title} className="w-20 h-20 object-contain" />
              

              {/* Title with Matching Color */}
              <h3 className={`mt-4 text-xl font-bold ${step.textColor}`} style={{fontFamily:'PT Sans'}}>
                {step.title}
              </h3>

              {/* Description */}
              <p className="mt-2 leading-relaxed text-black max-w-[280px] break-words text-wrap text-left">
                {step.description}
              </p>
            </div>
          ))}
        </motion.div>
      </div>
    </div>
  );
}
